import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkModule, MediaModule, PageComponentModule } from '@spartacus/storefront';
import { GgMediaWithMobileMediaModule } from '../gg-media-with-mobile-media/gg-media-with-mobile-media.module';
import { GgGridExtendedItemComponent } from './gg-grid-extended-item/gg-grid-extended-item.component';
import { GgGridComponent } from './gg-grid.component';

@NgModule({
  declarations: [GgGridExtendedItemComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GGGridComponent: {
          component: GgGridComponent,
        },
        GGGridExtendedItemComponent: {
          component: GgGridExtendedItemComponent,
        },
      },
    } as CmsConfig),
    PageComponentModule,
    MediaModule,
    RouterModule,
    GenericLinkModule,
    GgMediaWithMobileMediaModule,
  ],
})
export class GgGridModule {}
